if (typeof debounce === 'undefined') {
  var debounce = function(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
}
/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = document.querySelector('.mobile-toggle-wrapper');
      this._scrollTicking = false;
      this._stickyOffset = 0;

      document.addEventListener('keyup', (e) => {
        if (e.code?.toUpperCase() === 'ESCAPE') {
          this.toggle.removeAttribute('open');
          this.toggle.classList.remove('active');
        }
      });
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
        window.dispatchEvent(new Event('resize.resize-select'));
      });

      // Cache sticky offset and recalculate on resize
      this._cacheStickyOffset();
      window.addEventListener('resize', debounce(() => {
        this._cacheStickyOffset();
      }, 100));

      // Single scroll listener with rAF throttle
      window.addEventListener('scroll', () => {
        if (!this._scrollTicking) {
          this._scrollTicking = true;
          requestAnimationFrame(() => {
            this.setStickyClass();
            this.setHeaderOffset();
            this.setHeaderHeight();
            this._scrollTicking = false;
          });
        }
      }, { passive: true });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {
        window.addEventListener('scroll', () => this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    _cacheStickyOffset() {
      if (this.classList.contains('header-sticky--active')) {
        // Skip recalculation while sticky — the header is position:sticky at top:0,
        // so getBoundingClientRect().top would return 0 and corrupt the offset.
        if (this.classList.contains('is-sticky')) {
          return;
        }
        this._stickyOffset = parseInt(this.header_section.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
      }
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        this.classList.toggle('is-sticky', window.scrollY >= this._stickyOffset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.getElementById('shopify-section-announcement-bar');
      if (a_bar) {
        let h = a_bar.clientHeight;
        document.documentElement.style.setProperty('--announcement-height', h + 'px');
      }
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentLinksEnabled = this.menu.dataset.parentLinks === 'true';

      // When parent links setting is on, only arrow opens submenu
      if (parentLinksEnabled) {
        event.preventDefault();
        const isArrowClick = event.target.closest('.link-forward');

        if (!isArrowClick) {
          const anchor = summaryElement.querySelector('a');
          if (anchor && anchor.href) {
            window.location.href = anchor.href;
          }
          return;
        }
        // Arrow clicked — manually open details
        detailsElement.setAttribute('open', '');
      }

      const parentMenuElement = detailsElement.closest('.link-container');

      // Stamp deferred template content on first open
      const tpl = detailsElement.querySelector(':scope > template.mobile-menu-deferred');
      if (tpl) {
        tpl.replaceWith(tpl.content.cloneNode(true));
        // Re-bind back buttons for the newly stamped content
        detailsElement.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
        detailsElement.querySelectorAll('details.link-container summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      }

      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.submenus.length) {
        return;
      }
      // resize on initial load
      window.addEventListener('resize', debounce(() => {
        this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(() => {
        this.resizeSubMenus();
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
/**
 * App embeds (loyalty gift CTAs, spin wheels, chat bubbles) append fixed-position
 * launchers straight to <body>, so they float above the open mega menu and above the
 * open mobile menu drawer. Tag those launchers, then hide only the ones whose box
 * actually overlaps the open panel — a mega menu that stops short of the viewport
 * bottom leaves the launcher below it visible. Matching on app class names alone
 * misses widgets rendered inside an iframe or a shadow root, so the tagging is
 * structural: anything fixed that the theme does not own. Apps inject late and
 * re-render, so the scan repeats.
 */
(() => {
  // The header section re-runs its scripts on every render in the theme editor.
  if (window.themeFloatingWidgetWatcher) {
    return;
  }
  window.themeFloatingWidgetWatcher = true;

  const WIDGET_CLASS = 'js-floating-app-widget';
  const HIDDEN_CLASS = 'is-hidden-by-open-menu';
  // cart-notification-popup and modal-dialog move themselves to <body> and are fixed,
  // so they look like app launchers — they are the theme's own and must stay put.
  // [data-ignore-menu-overlap] is the opt-out for any other element that should too.
  const SKIP = [
    'script', 'style', 'link', 'noscript', 'template',
    '#wrapper', '.screen-reader-shortcut', '.pswp',
    'cart-notification-popup', 'modal-dialog', '[data-ignore-menu-overlap]'
  ].join(', ');
  // Known app launchers, for the ones that mount somewhere other than <body>.
  const APP_LAUNCHERS = '[id*="nector" i], [class*="nector" i]';
  const OPEN_PANELS = [
    '.thb-full-menu > li.menu-item-has-megamenu:hover > .mega-menu-container',
    '.thb-full-menu > li.menu-item-has-megamenu:focus-within > .mega-menu-container',
    '.mobile-toggle-wrapper[open].active .mobile-menu-drawer'
  ].join(', ');
  const MAX_NODES_SCANNED = 60;
  // Hide a launcher that stops just shy of the panel edge rather than leave it crowding it.
  const OVERLAP_GAP = 8;

  const isFixed = (element) => getComputedStyle(element).position === 'fixed';
  const hasBox = (rect) => rect.width > 0 && rect.height > 0;

  const overlaps = (widget, panel) =>
    widget.left < panel.right + OVERLAP_GAP &&
    widget.right > panel.left - OVERLAP_GAP &&
    widget.top < panel.bottom + OVERLAP_GAP &&
    widget.bottom > panel.top - OVERLAP_GAP;

  // A launcher is often a static wrapper around the fixed element, so look inside too.
  // visibility: hidden inherits, so hiding the wrapper still hides the fixed child.
  const isFloatingWidget = (element) => {
    if (isFixed(element)) {
      return true;
    }
    const roots = element.shadowRoot ? [element, element.shadowRoot] : [element];

    return roots.some((root) => {
      const nodes = root.querySelectorAll('*');

      for (let i = 0; i < Math.min(nodes.length, MAX_NODES_SCANNED); i++) {
        if (isFixed(nodes[i])) {
          return true;
        }
      }
      return false;
    });
  };

  let frame = null;
  const syncHiddenWidgets = () => {
    if (frame) {
      return;
    }
    // Deferred to the next frame so :hover and :focus-within have settled after the
    // event that triggered this, and so a burst of events costs one measurement.
    frame = requestAnimationFrame(() => {
      frame = null;

      const widgets = document.querySelectorAll(`.${WIDGET_CLASS}`);

      if (!widgets.length) {
        return;
      }
      const openPanels = document.querySelectorAll(OPEN_PANELS);

      // Nothing open — the common case, including every scroll frame. Clear any leftover
      // hidden state without measuring, so scrolling never pays for a forced layout.
      if (!openPanels.length) {
        document.querySelectorAll(`.${HIDDEN_CLASS}`).forEach((widget) => {
          widget.classList.remove(HIDDEN_CLASS);
        });
        return;
      }
      // Hidden launchers keep their layout box, so an open panel can be re-measured
      // against them without the measurement flickering as they hide and show.
      const panels = Array.from(openPanels)
        .map((panel) => panel.getBoundingClientRect())
        .filter(hasBox);

      widgets.forEach((widget) => {
        const rect = widget.getBoundingClientRect();
        const covered = hasBox(rect) && panels.some((panel) => overlaps(rect, panel));

        widget.classList.toggle(HIDDEN_CLASS, covered);
      });
    });
  };

  const tagFloatingWidgets = () => {
    const launchers = new Set();

    Array.from(document.body.children).forEach((element) => {
      if (!element.matches(SKIP) && isFloatingWidget(element)) {
        launchers.add(element);
      }
    });
    document.querySelectorAll(APP_LAUNCHERS).forEach((element) => {
      if (isFixed(element)) {
        launchers.add(element);
      }
    });
    document.querySelectorAll(`.${WIDGET_CLASS}`).forEach((element) => {
      if (!launchers.has(element)) {
        element.classList.remove(WIDGET_CLASS, HIDDEN_CLASS);
      }
    });
    launchers.forEach((element) => element.classList.add(WIDGET_CLASS));

    syncHiddenWidgets();
  };

  const scheduleScan = debounce(tagFloatingWidgets, 200);

  tagFloatingWidgets();
  window.addEventListener('load', scheduleScan);
  // Nector's visitor widget waits 2.5s before it appears; others mount on their own timers.
  [1000, 3000, 6000].forEach((delay) => setTimeout(scheduleScan, delay));
  new MutationObserver(scheduleScan).observe(document.body, { childList: true });

  const fullMenu = document.querySelector('.thb-full-menu');

  if (fullMenu) {
    // mouseover/mouseout rather than mouseenter/mouseleave: these bubble from the
    // menu items, so one listener per event covers every mega menu trigger.
    ['mouseover', 'mouseout', 'focusin', 'focusout'].forEach((type) => {
      fullMenu.addEventListener(type, syncHiddenWidgets);
    });
  }

  const mobileToggle = document.querySelector('.mobile-toggle-wrapper');

  if (mobileToggle) {
    // The drawer's .active class lands a tick after the click and is removed a frame
    // before [open] on close, so watch the attributes instead of the click.
    new MutationObserver(syncHiddenWidgets).observe(mobileToggle, {
      attributes: true,
      attributeFilter: ['class', 'open']
    });
  }

  // An open panel moves with the sticky header and its max-height is viewport based.
  window.addEventListener('scroll', syncHiddenWidgets, { passive: true });
  window.addEventListener('resize', syncHiddenWidgets);
})();
